<div class="list-container">
  <form [formGroup]="searchForm">
    <bw-input-legacy
      label="Employer"
      type="text"
      placeholder="Search"
      formControlName="inputText"
      [disabled]="showProcessSpinner"
    ></bw-input-legacy>
  </form>

  <bw-spinner-legacy *ngIf="showProcessSpinner; else notLoading"></bw-spinner-legacy>

  <ng-template #notLoading>
    <div *ngIf="!hideBeforeTyping || (hideBeforeTyping && !isEmptySearchText)" class="list-display-container">
      <ng-container *ngIf="displayedListItems.length > 0; else noRecordsFound">
        <bw-cell-legacy
          *ngFor="let displayItem of displayedListItems"
          [contentLeft]="true"
          [iconNameRight]="'chevron_right'"
          [separatorType]="'full'"
          (clicked)="onCompanyClicked(displayItem.code)"
        >
          <ng-container content-left>
            <typography-legacy text-medium-regular>
              <p>{{ displayItem.displayName }}</p>
            </typography-legacy>
          </ng-container>
        </bw-cell-legacy>
      </ng-container>
      <ng-template #noRecordsFound>
        <p class="body bs-light-gray" style="margin-top: 16px; margin-left: 16px; margin-right: 16px;">Sorry no matches</p>
      </ng-template>
    </div>
  </ng-template>
</div>
